
import { __ } from 'bits/intl'
import { currentPath } from 'bits/location'
import { Component, namespace, Vue } from 'bits/vue'
import BaseButtonIcon from 'library/v4/components/base-button-icon.vue'
import BaseIcon from 'vuecomponents/base_button.vue'
import PadletLogo from 'vuecomponents/PadletLogo.vue'
import SidebarFooter from 'vuecomponents/sidebar_footer.vue'

const authButtons = {
  login: {
    href: '/auth/login',
    size: 'normal',
    colorScheme: 'white',
    iconName: 'forward_button',
    position: 'top',
    secondIcon: 'true',
    secondIconName: 'arrow_right',
    border: 'true',
    class: 'login-button',
    text: __('Log in'),
  },
  signUp: {
    href: '/auth/signup',
    size: 'normal',
    colorScheme: 'white',
    iconName: 'sign_up',
    position: 'bottom',
    secondIcon: 'true',
    secondIconName: 'arrow_right',
    border: 'true',
    text: __('Sign up'),
  },
}

const homeAuthButton = {
  login: {
    href: '/auth/login',
    size: 'normal',
    colorScheme: 'white',
    iconName: 'forward_button',
    secondIcon: 'true',
    secondIconName: 'arrow_right',
    border: 'true',
    text: __('Log in'),
  },
}

const navButtons = {
  home: {
    id: 'nav-home',
    href: '/',
    iconName: 'home',
    text: __('Home'),
  },
  product: {
    id: 'nav-product',
    href: '/features',
    iconName: 'cupcake_filled',
    text: __('Product'),
  },
  memberships: {
    id: 'nav-memberships',
    href: '/memberships',
    iconName: 'crown',
    text: __('Memberships'),
  },
}

@Component({
  components: {
    BaseButtonIcon,
    PadletLogo,
    SidebarFooter,
    BaseIcon,
  },
})
export default class BaseSidebar extends Vue {
  @namespace('browser').State darkMode
  navButtons = navButtons
  authButtons = authButtons
  homeAuthButton = homeAuthButton
  authButtonList: object | null = null

  mounted(): void {
    if (currentPath().includes('/memberships')) {
      document.getElementById('nav-memberships')?.classList.add('active')
      this.authButtonList = this.authButtons
    } else if (currentPath().includes('/features')) {
      document.getElementById('nav-product')?.classList.add('active')
      this.authButtonList = this.authButtons
    } else {
      document.getElementById('nav-home')?.classList.add('active')
      this.authButtonList = this.homeAuthButton
    }
  }
}
